/**
 * Time Management Service
 * @author Mohammed Chater <mchater@combustiongroup.com>
 */

import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {environment} from "../../environments/environment";
import {isNullOrUndefined} from "util";
@Injectable()
export class TimeService {

    /**
     * The actual date & time now
     */
    now: Date;

    constructor(){
        this.now = new Date();
    }

    /**
     * return the format needed for short date
     * @param date
     * @returns {string}
     */
    public getShortDate(date: number): string {
        //let new_date = this.utcToLocal(date);
        return moment(date).format('MM/DD/YYYY');
    }

    getDatePicketFormat(date: number){
        return moment(date).format('YYYY-MM-DD')
    }

    /**
     * return the format needed for the time
     * @param date
     * @returns {string}
     */
    public getTime(date: string): string {
        let new_date = this.utcToLocal(date);
        return moment(new_date, 'MM/DD/YYYY hh:mm A').format('hh:mm A');
    }

    /**
     * Human friendly date reformat
     * @param date
     * @returns {string}
     */
    public friendlyDate(date: Date) {
        return moment(date).format('MMM DD, YYYY hh:mm A');
    }

    /**
    * return the format needed for short date
    * @param date
    * @returns {string}
    */
    public getDateAndTimeLocal(date: Date): string {
    return moment(date).format('MM/DD/YYYY hh:mm A');
    }

    /**
     * Convert local date sto UTC string
     * @param date
     * @returns {string}
     */
    localToUTC(date: string){

        let my_utc_date = new Date(date).toUTCString();

        return my_utc_date
    }

    /**
     * Convert utc string to local date
     * @param date
     * @returns {Date}
     */
    utcToLocal(date: string){
        const my_local_date = new Date(date).toLocaleString('en-US', { timeZone: environment.timezone });
        return my_local_date;
    }

    getTimezoneTine(timezone: string){
        const my_local_date = new Date().toLocaleString('en-US', { timeZone: timezone });
        return my_local_date;
    }

    /**
     * check if date is late or in front
     * @param date
     * @returns {boolean}
     */
    isPast(date){
        let a = +moment(date);
        const seconds = Math.floor((+new Date() - a) / 1000);
        return (Math.floor(seconds) > 0)
    }

    /**
     * convert date string to < since time > format
     * @param date {string}
     * @returns {string}
     */
    isLate(date: number) {

        if(isNullOrUndefined(date)){
            return 'No deadline'
        }else{

            let a = +moment(date);

            const seconds = Math.floor((+new Date() - a) / 1000);
            let interval = Math.floor(seconds / 31536000);
            const string1 = 'Late by ';
            const string2 = ' from now';

            if (interval > 1) {
                return string1 + interval + " years";
            }

            if (interval < -1) {
                return  (-interval) + " years" + string2;
            }

            interval = Math.floor(seconds / 2592000);

            if (interval > 1) {
                return string1 + interval + " months";
            }

            if(interval < -1){
                return (-interval) + " months" + string2;
            }

            interval = Math.floor(seconds / 86400);

            if (interval > 1) {
                return string1 + interval + " days";
            }

            if(interval < -1) {
                return (-interval) + " days" + string2;
            }

            interval = Math.floor(seconds / 3600);

            if (interval > 1) {
                return string1 + interval + " hours";
            }

            if(interval < -1) {
                return (-interval) + " hours" + string2;
            }

            interval = Math.floor(seconds / 60);

            if (interval > 1) {
                return string1 + interval + " minutes";
            }

            if (interval < -1) {
                return (-interval) + " minutes" + string2;
            }

            interval = Math.floor(seconds);

            if (interval > 1) {
                return string1 + interval + " seconds";
            }

            if (interval < -1) {
                return (-interval) + " seconds" + string2;
            }
        }


    }


    gettime(code: string) {
        return environment.zones[code].zone[0];
    }

}



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/time.service.ts